import { defineMessages, useIntl } from 'react-intl'
import LogoRelax from 'assets/images/logos/Relax.svg'
import RelaxPicture1 from 'assets/images/zones/relax/relax_view_1.png'
import RelaxPicture2 from 'assets/images/zones/relax/relax_view_2.png'
import RelaxPicture3 from 'assets/images/zones/relax/relax_view_3.png'
import RelaxPicture4 from 'assets/images/zones/relax/relax_view_4.png'
import RelaxPicture5 from 'assets/images/zones/relax/relax_view_5.png'
import ZonesModalCategory, {
    BulletsMessages,
    BulletsValues,
} from 'routes/Tickets/sections/ZonesDescription/components/ZonesModal/components/ZonesModalCategory'
import { formatPrice } from 'helpers/helpers'
import { CABANA_PRICE } from 'constants/prices'

const ZonesCategoryRelax = () => {
    const { formatMessage } = useIntl()

    const name = formatMessage({
        id: 'zones.modal.relax_name',
        defaultMessage: 'Relax',
    })
    const description = formatMessage({
        id: 'zones.modal.relax_description',
        defaultMessage: 'Odpoczynek i wyciszenie w tropikach',
    })
    const bullets: BulletsMessages = defineMessages({
        pt0: {
            id: 'zones.modal.relax_bullet_1',
            defaultMessage: 'Wstęp do strefy Jamango',
        },
        pt1: {
            id: 'zones.modal.relax_bullet_2',
            defaultMessage: '10 basenów leczniczo-relaksacyjnych',
        },
        pt2: {
            id: 'zones.modal.relax_bullet_3',
            defaultMessage: '2 restauracje i 2 koktajl bary',
        },
        pt3: {
            id: 'zones.modal.relax_bullet_4',
            defaultMessage: 'Wellness & SPA <span>(zabiegi od 89 zł)</span>',
        },
        pt4: {
            id: 'zones.modal.relax_bullet_5',
            defaultMessage:
                'Strefa VIP z łożami Cabana <span>({price} zł/2 os.)</span>',
        },
    })
    const bulletsValues: BulletsValues = {
        price: formatPrice(CABANA_PRICE),
    }

    const images = [
        RelaxPicture1,
        RelaxPicture2,
        RelaxPicture3,
        RelaxPicture4,
        RelaxPicture5,
    ]

    return (
        <ZonesModalCategory
            iconUrl={LogoRelax}
            zoneName={name}
            hasAgeBadge
            shortDescription={description}
            bullets={bullets}
            bulletsValues={bulletsValues}
            images={images}
        />
    )
}

export default ZonesCategoryRelax
